
      if (window.location.pathname.includes('/auth')) {
        // Preload Lucide icons SVG for auth page
        const icons = ['mail', 'lock', 'user-plus'];
        icons.forEach(icon => {
          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'fetch';
          link.href = `/node_modules/lucide-react/dist/${icon}.svg`;
          link.crossOrigin = 'anonymous';
          document.head.appendChild(link);
        });
      }
    